import React from 'react';
import {
    CssBaseline,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@material-ui/core';

import { withStyles } from '@material-ui/core/styles';
import InfoIcon from '@material-ui/icons/InfoOutlined';

import Layout from './Layout';
import fetch from '../utilities/fetch';

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
        marginBottom: theme.spacing.unit * 3,
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.background.default,
        },
        cursor: 'pointer',
    },
    tableHead: {
        fontWeight: 'bold',
        fontSize: 14,
        // whiteSpace: 'nowrap',
    },
    customTableCell: {
        whiteSpace: 'nowrap',
    },
    simCard: {
        fontSize: 20,
    },
});

const CustomTableCell = withStyles(theme => ({
    head: {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

class GoodsInItems extends React.Component {
    state = {
        items: [],
    }

    async componentDidMount() {
        const url = new URL('https://api.portal2.payweeklycarpets.co.uk/core/items');
        const params = {
            itemAssignmentDescription: 'Goods In',
        };
        Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
        const data = await fetch(url).then(response => response.json());
        this.setState({ items: data });
    }

    handleLeadClick = (itemCode) => {
        this.props.history.push(`/item/${itemCode}`);
    }

    render() {
        const { classes } = this.props;
        const { items } = this.state;

        return (
            <Layout pageTitle="Items - Goods In">
                <CssBaseline />
                <Paper className={classes.root}>
                    <Table className={classes.table} padding="dense">
                        <TableHead>
                            <TableRow>
                                <CustomTableCell className={classes.tableHead}>#</CustomTableCell>
                                <CustomTableCell className={classes.tableHead}>Stock Code</CustomTableCell>
                                <CustomTableCell className={classes.tableHead}>Manufacturer</CustomTableCell>
                                <CustomTableCell className={classes.tableHead}>Model</CustomTableCell>
                                <CustomTableCell className={classes.tableHead}>Description</CustomTableCell>
                                <CustomTableCell className={classes.tableHead}>location</CustomTableCell>
                                <CustomTableCell className={classes.tableHead}>Assignment</CustomTableCell>
                                <CustomTableCell className={classes.tableHead}>Goods In</CustomTableCell>
                                <CustomTableCell align="center" />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {items.map((item, index) => {
                                console.log(item);
                                return (
                                    <TableRow onClick={() => this.handleLeadClick(item.code)} className={classes.row} key={item.code}>
                                        <CustomTableCell className={classes.customTableCell} component="th" scope="row">{index + 1}</CustomTableCell>
                                        <CustomTableCell className={classes.customTableCell} align="center">{item.code}</CustomTableCell>
                                        <CustomTableCell className={classes.customTableCell} align="left">{item.manufacturer}</CustomTableCell>
                                        <CustomTableCell className={classes.customTableCell} align="left">{item.modelNo}</CustomTableCell>
                                        <CustomTableCell className={classes.customTableCell} align="left">{item.shortDescription}</CustomTableCell>
                                        <CustomTableCell className={classes.customTableCell} align="left">{item.branch}</CustomTableCell>
                                        <CustomTableCell className={classes.customTableCell} align="left">{item.itemAssignmentDescription}</CustomTableCell>
                                        <CustomTableCell className={classes.customTableCell} align="left">{item.createdDate}</CustomTableCell>
                                        <CustomTableCell className={classes.customTableCell} align="left"><IconButton className={classes.button} aria-label="More info"><InfoIcon /></IconButton></CustomTableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </Paper>
            </Layout>
        );
    }
}

export default withStyles(styles)(GoodsInItems);
